import _objectSpread from "reshow-runtime/es/helpers/objectSpread2";
var keys = Object.keys;

var mergeStyleConfig = function mergeStyleConfig(styles, defaultStyles, injectStyles) {
  if (defaultStyles) {
    keys(defaultStyles).forEach(function (key) {
      return styles[key] = !styles[key] ? defaultStyles[key] : _objectSpread(_objectSpread({}, defaultStyles[key]), styles[key]);
    });
  }

  if (injectStyles) {
    keys(styles).forEach(function (key) {
      if (injectStyles[key]) {
        injectStyles[key][0] = _objectSpread(_objectSpread({}, injectStyles[key][0]), styles[key]);
      }
    });
  }
};

export default mergeStyleConfig;